import React from 'react';
import { styled } from 'styled-components';
import { useEditMode } from '../../hooks/useEditMode';
import { StyledDivComponent } from '../../dto/StyleCompRepository';
import editIcon from '../../../asset/icon/edit.png';
import UniversalIconBtn from '../headless/button/UniversalIconBtn';

interface MoleculeDivBtnProps {
  value: string;
  defaultValue: string;
  handleClick: () => void;
  DivChangeStyle: StyledDivComponent;
  DivStyle: StyledDivComponent;
}

const MoleculeDivBtn: React.FC<MoleculeDivBtnProps> = ({
  value,
  defaultValue,
  handleClick,
  DivChangeStyle,
  DivStyle,
}) => {
  const { isEditMode } = useEditMode();

  return (
    <MoleculeDivBtnWrapper>
      {isEditMode ?
        <>
          <DivChangeStyle> {!value ? defaultValue : value} </DivChangeStyle>
          <UniversalIconBtn
            size="fit"
            border={false}
            backgroundImg={editIcon}
            onClick={handleClick}
          />
        </>
        :
        <DivStyle>{!value ? defaultValue : value}</DivStyle>
      }
    </MoleculeDivBtnWrapper>
  );
};


export default MoleculeDivBtn;


export const MoleculeDivBtnWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 0.5vw;
`;